import { v4 as uuid } from 'uuid';
import store from '@/store';

export default {
  add(push) {
    const identified = { ...push, id: uuid() };

    store.commit('push/add', identified);

    setTimeout(() => { store.commit('push/remove', identified); }, 5000);
  },
};
